import DropDown from '@/components/profile/dropDown'
import { countryList } from "@/assets/countryList"
import "./numberWithCountry.css"
export default function NumberWithCountry(props: any) {

    const setClass = () => {
        if (props.readOnly) {
            return "profileNumberWithCountry_readOnly"
        } else {
            return "profileNumberWithCountry_NotreadOnly"
        }
    }
    return (
        <div className="flex gap-3 items-center">
            <DropDown
                options={countryList}
                value={props.countryCode}
                onChange={props.onChangeCountryCode}
                placeholder={props.countryCodePlaceholder}
                lableFontSize="25px"
                width="fit-content"
                paddingControl="0px 0px"
                readOnly={props.readOnly}
                width_="80px"
            />

            {/* <input
                style={{
                    backgroundColor: props.readOnly ? "#f1f1f1" : "#ffffff",
                }}
                readOnly={props.readOnly}
                onChange={props.onChangeNumber}
                className="border-[1px] !border-[#e5e5e5] rounded-[5px] px-[10px] py-[8px] w-[100%] color-[#707172]"
                placeholder={props.contactNumberPlaceholder}
                value={props.contactNumber}
                type="text" /> */}

            <div className="relative w-[100%]">
                <input
                    value={props.contactNumber}
                    onChange={props.onChangeNumber}
                    readOnly={props.readOnly}
                    type="text"
                    id="floating_outlined"
                    className={`
                    ${setClass()}
                    profileNumberWithCountryInputBox
                    px-2.5 
                    pb-2.5 
                    pt-3 
                    w-[100%] 
                    text-[16px]
                    rounded-[5px] 
                    focus:outline-none peer`} placeholder=" " />
                <label
                    htmlFor="floating_outlined"
                    className={`
                    ${setClass()}
                    profileNumberWithCountryInputBoxLabel
                    absolute text-[16px]
            duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1`}>
                    {props.contactNumberPlaceholder}
                </label>
            </div>



        </div>
    );
}
